import './LanguageSwitcher.css'
import { useTranslation } from 'react-i18next'
import { useClaimForm } from '../context/ClaimFormContext'
import { DEFAULT_LANGUAGE } from '../utils/language'

function GermanFlag() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 12" className="lang-flag" aria-hidden="true">
      <rect width="16" height="4" fill="#000" />
      <rect y="4" width="16" height="4" fill="#DD0000" />
      <rect y="8" width="16" height="4" fill="#FFCE00" />
    </svg>
  )
}

function UkFlag() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 30" className="lang-flag" aria-hidden="true">
      <defs>
        <clipPath id="ukClip">
          <rect width="60" height="30" />
        </clipPath>
      </defs>
      <rect width="60" height="30" fill="#012169" />
      <path d="M0 0 L60 30 M60 0 L0 30" stroke="#fff" strokeWidth="6" clipPath="url(#ukClip)" />
      <path d="M0 0 L60 30 M60 0 L0 30" stroke="#C8102E" strokeWidth="4" clipPath="url(#ukClip)" />
      <path d="M30 0 V30 M0 15 H60" stroke="#fff" strokeWidth="10" clipPath="url(#ukClip)" />
      <path d="M30 0 V30 M0 15 H60" stroke="#C8102E" strokeWidth="6" clipPath="url(#ukClip)" />
    </svg>
  )
}

const LANGUAGES = [
  { code: 'de', label: 'DE', Flag: GermanFlag },
  { code: 'en', label: 'EN', Flag: UkFlag },
]

function LanguageSwitcherInner({ setLanguage }) {
  const { i18n } = useTranslation()
  const lang = i18n.language?.slice(0, 2) || DEFAULT_LANGUAGE

  return (
    <div className="lang-toggle" role="group" aria-label={i18n.t('common.language', { defaultValue: 'Sprache wählen' })}>
      {LANGUAGES.map(({ code, label, Flag }) => {
        const active = lang === code
        return (
          <button
            key={code}
            type="button"
            className={`lang-btn${active ? ' active' : ''}`}
            aria-pressed={active}
            onClick={() => setLanguage(code)}
          >
            <Flag /> <span>{label}</span>
          </button>
        )
      })}
    </div>
  )
}

function LanguageSwitcher() {
  const { i18n } = useTranslation()
  const { updateField } = useClaimForm()
  const setLanguage = (code) => {
    i18n.changeLanguage(code)
    updateField('language', code)
  }
  return <LanguageSwitcherInner setLanguage={setLanguage} />
}

export { LanguageSwitcherInner }
export default LanguageSwitcher
